<template>
<div>
<!--
<div class="custom-file_">
    <input ref="inputFile" class="form-control" type="file"   @click="resetInputFile()" @change="previewFile($event)" />
</div>
-->

<div class="custom-file">
  
  <input accept=".csv"  :disabled="type=='disabled'" :placeholder="'filename'" ref="inputFile" type="file" class="custom-file-input" id="customFile"  @click="resetInputFile()" @change="previewFile($event)">
  <label class="custom-file-label" data-browse="SCEGLI FILE" for="customFile">{{ filename ? filename :'Caricamento da file' }}</label>
  
</div>


</div>
</template>
<script>
//import api                 from "@/api";
export default {

  props      : ['type','typeId'],
     
 data () {
    return {
      filename: ''
    }
  },
  computed: {
 
  },
mounted()
{

},  

created()
{
  
},
methods :
{

    resetInputFile()
    {
     
      const items = []
      this.$refs["inputFile"].value = "";
      this.$emit('update',items)
      this.filename = ''
      
    },

    previewFile(evt) 
    {
      
      const file = evt.target.files[0];
      const reader = new FileReader();

      reader.addEventListener(
        "load",() => 
      {
      
        //const items = reader.result.split('\r\n')              
        const items = reader.result
        
        if(this.type == 'EanSupplierUpdate')
        { 
           this.$emit('update',items)
           return
        }
        
        if(this.type == 'stockMatching')
        { 
          
           this.$emit('update',items)
           return
        }
        //console.log(items)
        const barcodes = this.setData(items)
       
       
        if(barcodes.length > 0)
        {
          
          this.$emit('update',barcodes)
        }
      
      
      },
      false
      )

      reader.addEventListener("error", () => {
        console.error(`Error occurred reading file: ${file.name}`);
      });

      if (file) 
      {
       
        this.filename = file.name
        reader.readAsText(file);
      }

    },
  

  
  csvToArray(data,headers,delimiter = ',') {
 
 
  const lines = data.split(/\r?\n/)
  
  const result = [];

  for (let i = 1; i < lines.length; i++) {
    
    const obj = {};
    const currentline = lines[i].split(delimiter)  
    headers.forEach((header, index) => {    
      obj[header] = currentline[index]     
    });

    result.push(obj);
  }
  
  
  return result
  
  },




  
  setData(items)
  {
       
    let check = 0
    let barcodes = []
    
    if(this.type == 'PriceListUpdate')
    { 
        
        const headers = []
        if(this.typeId == 1 )
        {
          headers.push('barcode')
        
        }
        else if(this.typeId == 2)
        {
          headers.push('barcode')
          headers.push('discount')
        
        }
        else if(this.typeId == 3)
        {
          headers.push('barcode')
          headers.push('price')
        
        }
        else if(this.typeId == 4)
        {

          headers.push('productId')
          headers.push('discount')

        }
        
        barcodes = this.csvToArray(items,headers)
        
    }
    
   
   
    else if (this.type == 'test')
    {
      items.forEach(item =>{
         
          const cols = item.split(';');
                          
     })
     
     
    }
    if(check)
     {
      console.log('CHECK')
      return []
     }
     else
     {
      console.log('return barcodes')
      return barcodes 
     }
    

  }

}

}

</script>
<style scoped>
.custom-file-input
{
  cursor: pointer;
}

</style>